import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import ReactQuill from 'react-quill';
import swal from 'sweetalert2';

var Editor = /*#__PURE__*/function (_Component) {
  _inherits(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor(props) {
    var _this;

    _classCallCheck(this, Editor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setQuill", function (element) {
      return _this.quill = element;
    });

    _defineProperty(_assertThisInitialized(_this), "disableEvent", function (e) {
      e.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.disabled) {
        var quill = _this.quill.getEditor();

        quill.disable();
      }

      var element = document.querySelector('.ql-toolbar');

      if (element) {
        element.addEventListener('mousedown', _this.disableEvent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      var element = document.querySelector('.ql-toolbar');

      if (element) {
        element.removeEventListener('mousedown', _this.disableEvent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "imageHandler", function () {
      var quill = _this.quill.getEditor();

      var range = quill.getSelection();
      swal.fire({
        title: _this.props.translate('embed-image'),
        text: _this.props.translate('enter-url'),
        input: 'text',
        inputPlaceHolder: _this.props.translate('enter-url'),
        confirmButtonText: _this.props.translate('embed'),
        focusConfirm: false
      }).then(function (result) {
        if (result.value != null || result.value != '') {
          quill.insertEmbed(range.index, 'image', result.value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "videoHandler", function () {
      var quill = _this.quill.getEditor();

      var range = quill.getSelection(); // We need to figure out how to generate an embed link for all types of videos
      // Its easy to do with youtube but unsure about vimeo etc.
    });

    _defineProperty(_assertThisInitialized(_this), "urlHandler", function (promptRange) {
      var quill = _this.quill.getEditor();

      if (promptRange) {
        swal.fire({
          title: _this.props.translate('embed-content'),
          text: _this.props.translate('enter-url'),
          input: 'text',
          confirmButtonText: _this.props.translate('embed'),
          focusConfirm: false
        }).then(function (result) {
          if (result.value != null && result.value != '') {
            var url = result.value; // Add https if the url is missing a protocol

            if (url.indexOf('mailto:') == -1 && url.indexOf('tel:') == -1 && url.indexOf('ftp:') == -1) {
              if (!url.match(/^[a-zA-Z]+:\/\//)) {
                url = 'https://' + url;
              }

              quill.format('link', url);
            } else {
              quill.format('link', false);
            }
          }
        });
      }
    });

    var placeHolderText = '';

    if (_this.props.placeholder) {
      placeHolderText = _this.props.placeholder;
    }

    _this.state = {
      placeHolderText: placeHolderText
    };
    _this.modules = {
      toolbar: {
        container: [[{
          header: [2, 3, false]
        }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
          'color': ['#000000', '#ffffff', '#ffbe40', '#ff3149', '#86b100']
        }, {
          'background': ['#000000', '#ffffff', '#ffbe40', '#ff3149', '#86b100']
        }], [{
          list: 'ordered'
        }, {
          list: 'bullet'
        }], ['link', 'image', 'video', 'clean'], ['formula']],
        handlers: {
          image: _this.imageHandler,
          link: _this.urlHandler
        }
      }
    };
    _this.quill = null;
    return _this;
  }

  _createClass(Editor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var meta = this.props.meta;
      var formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'color', 'background',
      /* 'indent', */
      'link', 'image', 'video', 'formula'];
      return /*#__PURE__*/React.createElement("div", null, this.props.label ? /*#__PURE__*/React.createElement("label", null, this.props.label) : null, /*#__PURE__*/React.createElement(ReactQuill, {
        modules: this.modules,
        formats: formats,
        placeholder: this.state.placeHolderText,
        ref: this._setQuill,
        style: meta !== null && meta !== void 0 && meta.touched && meta !== null && meta !== void 0 && meta.error ? {
          border: '1px solid red'
        } : {},
        onChange: function onChange(value, delta, source, editor) {
          var newValue = editor.getHTML();
          var matches = newValue.match(/&lt;iframe(.*?)\&lt;\/iframe/g);

          if (matches != null) {
            matches.map(function (match) {
              var result = match;
              result = result.replace('<p>', ' ');
              result = result.replace('</p>', '');
              result = result.replace('&nbsp;', ' ');
              newValue = newValue.replace(match, result);
            });
          }

          if (_this2.props.input != null) {
            _this2.props.input.onChange(newValue);
          }

          if (_this2.props.onChange != null) {
            _this2.props.onChange(newValue);
          }
        },
        value: this.props.input ? this.props.input.value : this.props.value,
        onBlur: function onBlur(range, source, quill) {
          if (_this2.props.input) {
            _this2.props.input.onBlur(quill.getHTML());
          }

          if (_this2.props.onBlur != null) {
            _this2.props.onBlur(quill.getHTML());
          }
        }
      }), meta != null ? /*#__PURE__*/React.createElement("div", null, meta.touched && (meta.error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: 0
        },
        className: "error"
      }, meta.error) || meta.warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: 0
        },
        className: "error"
      }, meta.warning))) : null);
    }
  }]);

  return Editor;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(Editor);